// src/utils/formatDate.js
export function formatDate(dateString, options = {}) {
    const date = new Date(dateString)
    const defaultOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }

    return date.toLocaleDateString('en-US', { ...defaultOptions, ...options })
}

export function formatDateTime(dateString) {
    const date = new Date(dateString)
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    })
}

export function formatTime(dateString) {
    const date = new Date(dateString)
    return date.toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
    })
}

export function isFutureDate(dateString) {
    return new Date(dateString) > new Date()
}

export function isPastDate(dateString) {
    return new Date(dateString) < new Date()
}

export function getRelativeTime(dateString) {
    const date = new Date(dateString)
    const now = new Date()
    const diffInMs = now - date
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))

    if (diffInDays === 0) {
        return 'Today'
    } else if (diffInDays === 1) {
        return 'Yesterday'
    } else if (diffInDays < 7) {
        return `${diffInDays} days ago`
    } else if (diffInDays < 30) {
        const weeks = Math.floor(diffInDays / 7)
        return `${weeks} week${weeks > 1 ? 's' : ''} ago`
    } else if (diffInDays < 365) {
        const months = Math.floor(diffInDays / 30)
        return `${months} month${months > 1 ? 's' : ''} ago`
    } else {
        const years = Math.floor(diffInDays / 365)
        return `${years} year${years > 1 ? 's' : ''} ago`
    }
}